module.exports = __webpack_public_path__ + "img/stamp1.c82a879d.jpg";